import { render, staticRenderFns } from "./NewPrescription.vue?vue&type=template&id=7ab545c2&"
import script from "./NewPrescription.vue?vue&type=script&lang=js&"
export * from "./NewPrescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports